import type {RestTypeWithTypename} from '../rest-type-with-typename';
import type {FetchClosureDayQuery} from './fetch-closure-day';

export function fetchClosureDayPatcher(data: FetchClosureDayQuery): RestTypeWithTypename<FetchClosureDayQuery> {
    return {
        __typename: 'fetchClosureDayQuery',
        ...data,
        fetchClosureDays: {
            __typename: 'fetchClosureDay',
            ...data.fetchClosureDays,
        },
    };
}
